import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
import CardNetworks from '../../_common/cardNetworks.mdx';
import PossibleTypes from './onCardMetadataChangePossibleTypes.mdx';
import CardNetworksData from './onCardNetworksChangeCardNetworks.mdx';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Group = makeShortcode("Group");
const Item = makeShortcode("Item");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`Called when Headless Checkout detects new card networks from the card number entered by the user.`}</p>
    <p>{`Makes available an `}<inlineCode parentName="p">{`event`}</inlineCode>{` of type `}<inlineCode parentName="p">{`CardNetworkChangeEvent`}</inlineCode>{`.`}</p>
    <Group summary='CardNetworkChangeEvent' mdxType="Group">
      <Item title='detectedCardNetworks' subtitle='CardNetworks' mdxType="Item">
        <p>{`All the detected card networks, including the ones that are not allowed.`}</p>
        <p>{`Use the following snippet to get the card network that should be presented to the user:`}</p>
        <p><inlineCode parentName="p">{`detectedCardNetworks.preferred ?? detectedCardNetworks.items[0]`}</inlineCode></p>
        <CardNetworksData mdxType="CardNetworksData" />
      </Item>
      <Item title='selectableCardNetworks' subtitle='CardNetworks | undefined' mdxType="Item">
        <p>{`In case the card has zero or only one network that is allowed, `}<inlineCode parentName="p">{`undefined`}</inlineCode>{`. Otherwise, all the allowed cards.`}</p>
        <p>{`Use this to show the card networks the user can choose from in the case of a co-badged cards.`}</p>
        <CardNetworksData mdxType="CardNetworksData" />
      </Item>
  <Item title='source' subtitle="'REMOTE' | 'LOCAL' | 'LOCAL_FALLBACK'" mdxType="Item">
      The source of the information.
      <Group summary="Values" mdxType="Group">
          <Item title="LOCAL" mdxType="Item">
            <p>{`This happens when less than 8 digits are entered in the cardnumber field.`}</p>
            <p>{`Headless Checkout retrieved the card networks using static information bundled with the SDK. This information can only identify international cards.`}</p>
          </Item>
          <Item title="REMOTE" mdxType="Item">
            <p>{`This happens when 8 digits or more are entered in the cardnumber field.`}</p>
            <p>{`Headless Checkout retrieved the card networks using Primer's BIN data.`}</p>
          </Item>
          <Item title="LOCAL_FALLBACK" mdxType="Item">
            <p>{`This happens when Headless Checkout fails to contact Primer's BIN data.`}</p>
            <p>{`Falls back to the static information bundled with the SDK (see `}<inlineCode parentName="p">{`LOCAL`}</inlineCode>{`).`}</p>
          </Item>
      </Group>
  </Item>
    </Group>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      